import { IonBackButton, IonButtons, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import React from 'react';
import { Title } from '../Title';
import { useSettings } from '../../contexts/SettingsContext';

interface PageHeaderProps {
  title: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title }) => {
  const { networkId } = useSettings();

  const defaultHref = networkId ? `/${networkId}` : '/world';

  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton color="medium" defaultHref={defaultHref} />
        </IonButtons>
        <IonTitle>
          <Title>{title}</Title>
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

export default PageHeader;
